module.exports = __webpack_public_path__ + "img/galery15.e10fda34.jpg";